import Slider from './components/Slider';

const defaults = {
  selectedAttraction: 0.2, // default 0.025
  friction: 0.8, // default 0.28
  autoPlay: false,
  wrapAround: true,
  prevNextButtons: false,
  responsive: {
    desktop: {
      autoPlay: 4000,
      progressLoop: true,
      pauseAutoPlayOnHover: false,
      playPause: {
        shape: '<svg xmlns="http://www.w3.org/2000/svg" class="play-pause-icon" width="30" height="30" viewBox="0 0 30 30"><title>Play / Pause button</title><path class="play" d="M26.27,13.74,9.2,4.19a1.5,1.5,0,0,0-2,.51,1.43,1.43,0,0,0-.2.73V24.57A1.44,1.44,0,0,0,8.45,26a1.61,1.61,0,0,0,.75-.19l17.07-9.6a1.4,1.4,0,0,0,.53-2A1.55,1.55,0,0,0,26.27,13.74Z"/><g class="pause"><path d="M11.72,24H8.28A1.24,1.24,0,0,1,7,22.79V7.26A1.27,1.27,0,0,1,8.28,6h3.44A1.27,1.27,0,0,1,13,7.26V22.79A1.24,1.24,0,0,1,11.75,24Z"/><path d="M21.72,24H18.28A1.24,1.24,0,0,1,17,22.79V7.26A1.27,1.27,0,0,1,18.28,6h3.44A1.27,1.27,0,0,1,23,7.26V22.79A1.27,1.27,0,0,1,21.72,24Z"/></g></svg>',
        wrapperTag: false,
        attachTo: false,
      },
    },
  },
};

export default class HomeHero {
  constructor(element) {
    this.element = element;
    this.settings = defaults;
    this.Slider = new Slider(this.container, this.settings);
    this.element.classList.add('ready');
  }

  get container() {
    return this.element.querySelector('.block-content');
  }
}
